module.exports = {
  defaultTitle: 'Mr Wii',
  logo: 'https://mr-wii.com/logo-48.png',
  author: 'Ouail Bni (Mr Wii)',
  url: 'https://mr-wii.com',
  legalName: 'Ouail Bni',
  defaultDescription:
    'I am Wael, aka Mr Wii! a Front-End developer who enjoys making website and webapps and loves learning new things.',
  socialLinks: {
    twitter: 'https://twitter.com/BniWael',
    github: 'https://github.com/Mr-Wii',
    linkedin: 'https://www.linkedin.com/in/ouailbni/',
    instagram: 'https://www.instagram.com/wael_bni/',
    youtube: 'https://www.youtube.com/user/eruKenkyushitsu'
  },
  googleAnalyticsID: 'UA-156290568-1',
  themeColor: '#5e3da5',
  backgroundColor: '#fff',
  social: {
    facebook: '100006553743185',
    twitter: '@BniWael'
  },
  address: {
    city: 'Errachidia',
    region: 'Drâa-Tafilalet',
    country: 'Morocco',
    zipCode: '52000'
  },
  contact: {
    email: 'ouailbni@gmail.com',
    phone: '+212-639-03-23-34'
  },
  foundingDate: '2019'
}
